import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CfetNavHeaderComponent, CfetNavFooterComponent, UtfNavHeaderComponent } from './index';
import { CfetCoreModule } from '../cfet-core/cfet-core.module';
import { CfetNavigationDirective } from '../cfet-core';

@NgModule({
  declarations: [CfetNavHeaderComponent, CfetNavigationDirective, CfetNavFooterComponent, UtfNavHeaderComponent],
  imports: [
    CommonModule,
    CfetCoreModule
  ], schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [CfetNavHeaderComponent, CfetNavFooterComponent, UtfNavHeaderComponent]
})
export class CfetNavModule { }
